export const FRESH_CHAT_TOKEN = "eca2196f-aab4-4e16-b153-6e802d082eea";
export const FRESH_CHAT_URL = "https://wchat.freshchat.com";
